// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__23ymZ","messages":"Chat_messages__1-xxg","dateDivider":"Chat_dateDivider__3JUmJ"};